import React from "react";

export const BalloonEnvelope = () => (
    <svg width="213" height="281" viewBox="0 0 213 281" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M82.0152 146.856C73.9765 147.898 71.9668 141.215 71.9668 137.744C75.735 113.877 86.202 97.3944 114.673 93.9222C143.143 90.4499 160.309 131.235 159.89 137.744C159.472 144.253 156.541 143.819 151.935 146.856C148.586 153.799 140.212 153.365 131.839 149.894C114.254 159.874 103.368 149.894 99.1812 146.856C93.7383 152.931 87.8768 148.592 82.0152 146.856Z"
            fill="#EFDDC7"
        />
        <path
            d="M119.97 229.659H111.188"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M112.329 204.438C108.15 210.93 97.1359 223.951 101.722 229.758C107.122 235.211 129.043 258.649 139.329 269.685C142.367 272.256 144.85 271.061 148.954 266.547C150.046 265.346 154.122 260.234 155.541 258.203M144.124 243.392H125.829C122.936 235.925 116.572 218.851 114.258 210.281C111.944 201.711 116.018 200.676 120.043 204.438C120.043 204.438 132.149 214.287 141.489 222.633"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M135.779 243.712L140.171 263.912"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M114.351 88.2601C81.6865 88.2739 64.6391 122.071 67.2759 142.091C68.28 149.715 73.0401 151.703 75.9222 151.703C89.3721 182.464 101.861 194.96 112.429 204.573M114.351 88.2601C154.7 88.243 168.771 130.406 165.268 142.091C162.386 151.703 154.7 151.703 153.74 151.703M114.351 88.2601C120.851 88.2573 130.512 111.523 132.604 143.58C134.12 166.805 122.607 194.081 112.429 204.573M114.351 88.2601C106.602 88.2634 84.4022 149.736 112.429 204.573M153.74 151.703C152.779 155.548 142.807 160.715 132.385 155.006C126.998 161.154 108.555 161.593 98.814 151.703C92.3067 159.397 70.3498 155.006 81.3283 120.753C87.4762 104.066 99.9399 88.2573 114.351 88.2573C128.761 88.2573 153.74 115.175 153.74 151.703ZM153.74 151.703C153.74 165.098 132.604 191.885 112.429 204.573"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <ellipse
            cx="162.853"
            cy="237.663"
            rx="19.3551"
            ry="27.6501"
            transform="rotate(-30 162.853 237.663)"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M178.951 260.338C190.364 253.748 193.027 237.136 185.391 223.911C177.756 210.686 163 205.859 151.586 212.449"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M172.36 232.639C167.876 229.461 158.718 227.513 157.338 232.311C155.613 238.31 171.128 236.923 169.773 241.635C168.417 246.348 152.868 244.1 153.73 241.101"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M165.678 225.84L159.023 248.976"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <ellipse
            cx="195.351"
            cy="175.643"
            rx="9.3517"
            ry="13.3596"
            transform="rotate(-30 195.351 175.643)"
            fill="#C5D5E4"
        />
        <ellipse
            cx="202.856"
            cy="270.02"
            rx="6.32092"
            ry="9.02988"
            transform="rotate(-30 202.856 270.02)"
            fill="#E6C9C9"
        />
        <ellipse
            cx="77.2625"
            cy="203.753"
            rx="6.32092"
            ry="9.02988"
            transform="rotate(-30 77.2625 203.753)"
            fill="#E0E5CD"
        />
        <path
            d="M116.157 78.6571C133.918 47.3204 102.788 -2.92531 63.3453 33.0092C34.788 59.0266 87.7414 57.8644 93.8465 40.0013C99.1867 24.3762 76.1076 4.16385 10.9845 8.61853"
            stroke="#112D47"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="6 6"
        />
    </svg>
);
